import { Spacings } from "react-native-ui-lib";

export const cameraButtonStyles = {
  height: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: Spacings.s2,
  padding: Spacings.s2,
};
